import { useState, useContext } from "react";
import { Box, Paper, Typography, TextField, Button, IconButton, Alert } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useNavigate, Link } from "react-router-dom";
import { Brightness4, Brightness7 } from "@mui/icons-material";
import { ColorModeContext } from "../ThemeContext";
import { forgotPassword } from "../api/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const theme = useTheme();
  const colorMode = useContext(ColorModeContext);

  const isDark = theme.palette.mode === "dark";
  const paperBg = isDark ? "#23272f" : "#fff";
  const textColor = isDark ? "#fff" : "#23272f";

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMsg("");
    setLoading(true);
    try {
      await forgotPassword(email);
      setMsg("Se o e-mail existir, um código foi enviado. Verifique sua caixa de entrada e o spam.");
      setTimeout(() => navigate("/reset-password", { state: { email } }), 2500);
    } catch (err) {
      setMsg(
        err.response?.data?.error ||
        "Erro ao solicitar recuperação. Tente novamente."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: theme.palette.background.default,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center"
      }}
    >
      <Paper
        sx={{
          p: { xs: 3, sm: 4 },
          width: { xs: 320, sm: 370 },
          maxWidth: "95vw",
          borderRadius: 4,
          bgcolor: paperBg,
          color: textColor,
          position: "relative",
          boxShadow: 6,
        }}
      >
        <IconButton
          size="small"
          onClick={colorMode.toggleColorMode}
          sx={{ position: "absolute", top: 13, right: 13 }}
        >
          {isDark ? <Brightness7 /> : <Brightness4 />}
        </IconButton>
        <Typography variant="h5" gutterBottom align="center" sx={{ fontWeight: 700 }}>
          Esqueci minha senha
        </Typography>
        <form onSubmit={handleSubmit}>
          <TextField
            fullWidth
            label="E-mail cadastrado"
            margin="normal"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
            type="email"
          />
          <Button
            fullWidth
            variant="contained"
            color="primary"
            type="submit"
            sx={{ mt: 2, fontWeight: 600 }}
            disabled={loading}
          >
            Enviar código
          </Button>
        </form>
        <Typography variant="body2" align="center" sx={{ mt: 2 }}>
          <Link to="/login" style={{ color: theme.palette.primary.main, fontWeight: 500 }}>
            Voltar ao login
          </Link>
        </Typography>
        {msg && <Alert severity={msg.startsWith("Se o e-mail") ? "success" : "error"} sx={{ mt: 2, textAlign: "center" }}>{msg}</Alert>}
      </Paper>
    </Box>
  );
}

